import React from 'react';
import http from '../api';
import axios from 'axios';
import PopupFrameV2 from '../popup/PopupFrameV2';
import GptMarkdown from './GptMarkdown';
import { FirstDataSyncIntroPopup } from './FirstDataSyncIntroPopup';
import { ShopGptAnalisysLoadingPopup } from './ShopGptAnalisysLoadingPopup';
import { ShopGptAnalisysCompletePopup } from './ShopGptAnalisysCompletePopup';
import InputDialogTwoButtons from '../dialogs/InputDialogTwoButtons';
import BasicDialogV2 from '../dialogs/BasicDialogV2';
import x_img from '../../../resources/img/x.svg';

import * as StringUtil from '../utils/StringUtil';

let GptAnalysisStatus

export class ShopGptAnalisysPopup extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            title : "",
            sections : [],
            step : 1,

            showFirstDataSyncIntroPopup : false,
            showShopGptAnalisysPopup : false,
            showShopGptAnalisysLoadingPopup : false,
            showShopGptAnalisysCompletePopup : false,

            showFreeTrialExtenssionDialogState : true,
            showUserInfoInputDialogState : false,
        }
    }

    componentWillMount() {
        // this.getGptAnalysis();
        this.initGptAnalysisStatus();
        this.showContactInfoPopup();
    }

	componentDidMount() {
    
    }

    componentDidUpdate() {
    
    }

    componentWillUnmount(e) {
    
    }

    showContactInfoPopup(){
        http.get("/rest/shop/selectUserLatestContactInfo")
		.then(res => {
            console.log("기존 연락처 정보 불러오기 완료!!!");
            const data = res.data;
            this.setState({
                contact_user_name : data.contact_user_name,
			    contact_tel_no : data.contact_tel_no,
			    contact_email : data.contact_email,
            })
		})
		.catch(error => {
            console.error("기존 연락처 정보 불러오기 실패!!!", error);
		 });
    }

    getGptAnalysis = () => {
        this.setState({
            showFirstDataSyncIntroPopup : false,
            showShopGptAnalisysLoadingPopup : true,
        });

        axios.get("/rest/shop/gpt/product-name-based-sales-strategy").then((res) => {
            let gptResponse = res.data;
            
            // let gptResponse = orgGptRespnose; 

            let content = "";
            if (gptResponse?.response?.choices?.length > 0) {
                content = gptResponse.response.choices[0].message.content;
            }

            let parseMarkdownByHeading = this.parseMarkdownByMiddleHeadingOnly(content);
            this.setState({
                title: parseMarkdownByHeading.title,
                intro: parseMarkdownByHeading.intro,
                sections: parseMarkdownByHeading.sections,
                showShopGptAnalisysPopup : true,
                showShopGptAnalisysLoadingPopup : false,
            }, () => {
                console.log("title", this.state.title);
                console.log("intro", this.state.intro);
                console.log("sections", this.state.sections);
            });
        }) .catch((error) => {
            console.log(error);
            const status = error?.response?.status;
            const code = error?.code;

            // AWS CloudFront 504 타임아웃 감지
            const isCloudFrontTimeout = status === 504;

            // Axios 자체 timeout 감지
            const isAxiosTimeout = code === 'ECONNABORTED';

            if (isCloudFrontTimeout || isAxiosTimeout) {
                this.pollGptAnalysisStatus(); 
            }
        })
    }

    pollGptAnalysisStatus = (retryCount = 0) => {
        if (retryCount >= 10) {
            console.warn("GPT 분석 상태 확인 실패: 최대 재시도 횟수 초과");
            return;
        }
    
        setTimeout(() => {
            axios.get("/rest/shop/gpt/product-name-based-sales-strategy/status")
                .then((res) => {
                    if (res.data?.status === 'D') {
                        this.handleGptAnalysisResponse(res.data);
                    } else {
                        this.pollGptAnalysisStatus(retryCount + 1);
                    }
                })
                .catch((err) => {
                    console.error("상태 확인 실패", err);
                    this.pollGptAnalysisStatus(retryCount + 1);
                });
        }, 10000); // 10초 간격
    }

    initGptAnalysisStatus() {
        axios.get("/rest/shop/gpt/product-name-based-sales-strategy/status")
        .then((res) => {
            if (res.data?.status === 'D') {
                this.handleGptAnalysisResponse(res.data);
            } else if (res.data?.status === 'P') {
                this.pollGptAnalysisStatus(0);
            } else {
                // 분석 하시겠습니까?
                this.setState({
                    showFirstDataSyncIntroPopup : true,
                })
            }
        })
        .catch((err) => {
            console.error("상태 확인 실패", err);
        });
    }

    handleGptAnalysisResponse = (gptResponse) => {
        const content = gptResponse?.response?.choices?.[0]?.message?.content || "";
    
        const parsed = this.parseMarkdownByMiddleHeadingOnly(content);
        this.setState({
            title: parsed.title,
            intro: parsed.intro,
            sections: parsed.sections,
            showShopGptAnalisysPopup: true,
            showShopGptAnalisysLoadingPopup : false,
        }, () => {
            console.log("title", this.state.title);
            console.log("intro", this.state.intro);
            console.log("sections", this.state.sections);
        });
    };

    nextStep = (currentStep) => {
        if (this.state.sections.length == currentStep) {
            this.setState({
                showShopGptAnalisysPopup : false,
                showUserInfoInputDialogState : true
            })
            return;
        }

        this.setState({
            step: currentStep + 1
        })
    }
    prevStep = (currentStep) => {
        
    }

    onClickExtenssionBtnCirform (input_values) {
        if (!input_values[0]) {
            this.setState({
                showBasicDialogState : true,
                basicDialogContent : "담당자명을 입력해 주세요."
            })
            return false;
        }
        if (!input_values[1]) {
            this.setState({
                showBasicDialogState : true,
                basicDialogContent : "이메일을 입력해 주세요."
            })
            return false;
        }
        if (!input_values[2]) {
            this.setState({
                showBasicDialogState : true,
                basicDialogContent : "연락처를 입력해 주세요."
            })
            return false;
        }

        const body = {
            user_name: input_values[0],
            email: input_values[1],
            tel_no: input_values[2]
        }
        const config = {
            headers: {
                'content-type': 'application/json;'
            }
        }
        http.post("/rest/shop/insertUserGPTAnalisysExtension", body , config)
        .then(res => {
            console.log("상담 신청 완료!!!");
            this.setState({
                showUserInfoInputDialogState: false
            })
            this.props.onClose();

        }).catch(error => {
            console.log("상담 신청 실패!!!");
            console.log(error);
            this.setState({
                showUserInfoInputDialogState: false
            })
            this.props.onClose();
        });
    }

    parseMarkdownByMiddleHeadingOnly(markdown, serviceName = '') {
        const lines = markdown.split('\n');
    
        let title = '';
        const introLines = []; // 여러 줄 저장
        const sections = [];
    
        let currentSectionTitle = '';
        let currentSectionContent = [];
        let inSection = false;
    
        const sectionTitles = [];
    
        let foundTitle = false;
    
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
    
            if (line.startsWith('# ')) {
                title = line.trim();
                foundTitle = true;
            } else if (line.startsWith('## ')) {
                if (inSection && currentSectionTitle) {
                    sectionTitles.push(currentSectionTitle);
                    sections.push({
                        title: currentSectionTitle,
                        content: currentSectionContent.join('\n').trim()
                    });
                }
    
                inSection = true;
                currentSectionTitle = line.trim();
                currentSectionContent = [];
            } else {
                if (!inSection && foundTitle) {
                    introLines.push(line); // 여러 줄 계속 누적
                } else if (inSection) {
                    currentSectionContent.push(line);
                }
            }
        }
    
        // 마지막 섹션 처리
        if (currentSectionTitle || currentSectionContent.length > 0) {
            sectionTitles.push(currentSectionTitle);
            sections.push({
                title: currentSectionTitle,
                content: currentSectionContent.join('\n').trim()
            });
        }
    
        // 안내 문구 삽입
        for (let i = 0; i < sections.length; i++) {
            if (i < sections.length - 1) {
                const nextTitle = sections[i + 1].title.replace(/^##\s*/, '');
                sections[i].content += `
                    <br/>
                    <div class="next-section-suggestion">
                    다음으로 <strong>${nextTitle}</strong> 분석 확인해볼까요?
                    </div>`;
            } else {
                // const serviceText = serviceName ? `“${serviceName}”` : '“서비스명”';
                let serviceText = "기타";
                let path = window.location.pathname;
                if (path.includes("/shop/productDesign")) {
                    serviceText = "AI 상세페이지 디자인";
                } else if (path.includes("/productDetailDesign/admin")) {
                    serviceText = "AI 상세페이지 디자인<br/>(관리자)";
                } else if (path.includes("/shop/cafe24")) {
                    serviceText = "AI배너";
                } else if (path.includes("/shop/rp")) {
                    serviceText = "상품자동진열";
                } else if (path.includes("/shop/kdeal")) {
                    serviceText = "상세페이지 디자인";
                } else if (path.includes("/kdeal/admin")) {
                    serviceText = "상세페이지 디자인 (관리자)";
                } else if (path.includes("/fb")) {
                    serviceText = "트렌드 인사이트";
                } else if (path.includes("/shop/curation")) {
                    serviceText = "큐레이션";
                } else if (path.includes("/shop/targetview")) {
                    serviceText = "타겟뷰";
                } else if (path.includes("/shop/coupang")) {
                    serviceText = "랭킹 인사이트";
                } else if (path.includes("/shop/ai/rp")) {
                    serviceText = "AI추천";
                } else {
                    serviceText = "서비스명";
                }
                sections[i].content += `
                    <div class="final-section">
                    <p>분석정보에 따라서 <strong class="service-name">${serviceText}</strong>${StringUtil.getObjectParticle(serviceText)} 사용해서 자동운영을 설정해볼게요.</p>
                    <p>이제 설정에 대한 도움을 받도록 설정 대행 및 상담을 받아보시겠습니까?</p>
                    </div>`;
            }
        }
    
        return {
            title,
            intro: introLines.join('\n').trim(), // 여러 줄 붙여 반환
            sections: sections.map(s => `${s.title}\n${s.content}`)
        };
    }

    render() {
        return (
            <div>
                <div className="shopGptAnalisysPopup" style={{position:"fixed", zIndex: 99999}}>
                    {
                        this.state.showShopGptAnalisysPopup &&
                        <PopupFrameV2
                                className={"shopGptAnalisysPopupFrame"}
                                width={"90vw"}
                                maxWidth={"90vw"}
                                height={"90vh"}
                                maxHeight={"90vh"}
                                padding={"40px 0px 0px 0px"}
                                onClose={() => {
                                    this.props.onClose();
                                }}
                            >
                            <div className="flexBox" style={{flexDirection:'column', flexWrap:"nowrap", height:"100%"}}>
                                <div style={{flex:1, overflow:"auto"}}>
                                    <GptMarkdown
                                        title={this.state.title}
                                        intro={this.state.intro}
                                        section={this.state.sections && this.state.sections.length > 0 ? this.state.sections[this.state.step - 1] : ""}
                                        step={this.state.step}
                                    />
                                </div>
                                <div className='flexBox' style={{justifyContent: "center", height:"auto"}}>
                                    {
                                        this.state.step == this.state.sections.length 
                                        ?   <div id="canceltButton" 
                                                onClick={() => {
                                                    // this.setState({
                                                    //     showPopup: 0
                                                    // })
                                                    this.props.onClose();
                                                }}>{
                                                    "아니요. 직접 설정해볼게요."
                                            }</div> 
                                        : <></>
                                    }
                                    <div id="nextButton" onClick={() => {
                                        // IF (THIS.STATE.STEP == "7") {
                                        //     // 저장 및 미리보기 실행
                                        //     // THIS.CLONERPEVENTSETTING();
                                        // } ELSE {
                                            // 다음
                                            this.nextStep(this.state.step)
                                        // }
                                    }}>{
                                        this.state.step != this.state.sections.length ? "다음" : "예"
                                    }</div>
                                </div>
                            </div>
                        </PopupFrameV2>
                    }
                    {
                        this.state.showFirstDataSyncIntroPopup &&
                        <FirstDataSyncIntroPopup
                        onClose={() => {
                            this.setState({
                                showFirstDataSyncIntroPopup: false
                            })
                        }}
                        onConfirm= {() => {
                            this.getGptAnalysis();
                        }}
                        />
                    }
                    {
                        this.state.showShopGptAnalisysLoadingPopup &&
                        <ShopGptAnalisysLoadingPopup
                        onClose={() => {
                            this.setState({
                                showShopGptAnalisysLoadingPopup: false
                            })
                        }}
                        />
                    }
                    {
                        this.state.showShopGptAnalisysCompletePopup &&
                        <ShopGptAnalisysCompletePopup
                        onClose={() => {
                            this.setState({
                                showShopGptAnalisysCompletePopup: false
                            })
                        }}
                        />
                    }
                    {
                        this.state.showUserInfoInputDialogState &&
                        <InputDialogTwoButtons
                            title="환영합니다"
                            content= {<>
                                <div onClick={ () => {
                                        this.setState({
                                            showUserInfoInputDialogState: false
                                        })
                                        this.props.onClose();
                                    }
                                  } style={{ position: 'absolute', top: '-12px', right: '-1px', cursor: 'pointer' }}>
                                  <img src={x_img} alt="닫기 버튼" />
                                </div>
                                <div>
                                  설정에 대한 도움 및 상담을 받고 싶다면, 
                                  <br />
                                  담당자 연락처를 남겨주세요
                                </div>
                              </>}
                            input_list={[
                                { title: "담당자명", value: (this.state.contact_user_name ? this.state.contact_user_name : ""), placeholder: "진열연동 안내를 받으실 담당자명을 입력해 주세요." },
                                { title: "이메일", value: (this.state.contact_email ? this.state.contact_email : ""), placeholder: "안내 받으실 담당자 이메일 주소를 입력해주세요." },
                                { title: "연락처", value: (this.state.contact_tel_no ? this.state.contact_tel_no : ""), placeholder: "안내 받으실 담당자 연락처를 입력해주세요." },
                            ]}
                            button_white_text="상담문의"
                            onButtonWhiteClick={(values) => {
                                    window.location.href="/shop/qna/list"
                                }
                            }
                            button_mint_text="확인"
                            onButtonMintClick={(values) => {
                                    this.onClickExtenssionBtnCirform(values);
                                }
                            }
                        />
                    }
                    {
                        this.state.showBasicDialogState && 
                        <BasicDialogV2
                            content={this.state.basicDialogContent ? this.state.basicDialogContent : ""}
                            button_list={[{
                                title : "확인",
                                event_method : () => { this.setState({showBasicDialogState: false}) }
                            }]}
                        />
                    }
                </div>
            </div>
        )
    };
}